<template>
  <div>
    <nav>
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a
          @click="handleStep('LISTA_PRODUTO')"
          :class="[
            'nav-link link-nav-resident',
            step == 'LISTA_PRODUTO' && 'active',
          ]"
          id="nav-lista-produto"
          data-toggle="tab"
          href="#lista-produto"
          role="tab"
          aria-controls="lista-produto"
          aria-selected="true"
          >LISTAS (PRODUTO)</a
        >
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div
        v-if="step == 'LISTA_PRODUTO'"
        :class="['tab-pane fade', step == 'LISTA_PRODUTO' && 'show active']"
        id="lista-produto"
        role="tabpanel"
        aria-labelledby="nav-lista-produto"
      >
        <ListProduct :resident="resident" />
      </div>
    </div>
  </div>
</template>

<script>
import ListProduct from "./MenuList/ListProduct";

import routes from "../../routes";

export default {
  name: "MenuList",

  components: {
    ListProduct,
  },

  props: {
    resident: Object,
  },

  data() {
    return {
      step: "LISTA_PRODUTO",
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    handleStep(step) {
      let newNav;

      if (step == "LISTA_PRODUTO") {
        newNav = "list-produto";
      }

      if (step == "LISTA_MEDICAMENTO") {
        newNav = "list-medicamento";
      }

      let { tab, nav } = routes.history.current.query;

      if (nav != newNav) {
        routes.replace({ query: { tab, nav: newNav } });
      }

      this.step = step;
    },

    async retrieve() {
      const { nav } = routes.history.current.query;

      if (nav) {
        if (nav == "list-produto") {
          this.step = "LISTA_PRODUTO";
        }
        if (nav == "list-medicamento") {
          this.step = "LISTA_MEDICAMENTO";
        }
      }
    },

    handleToResident(resident_id) {
      this.$emit("handleToResident", resident_id);
    },
  },
};
</script>